import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getToken } from '../lib/api';

const SEVERITY_COLORS: any = {
  info: 'badge-up',
  warn: 'badge-warn',
  error: 'badge-down',
};

export default function ActivityLog() {
  const [source, setSource] = useState('');
  const [severity, setSeverity] = useState('');
  const [search, setSearch] = useState('');

  const { data } = useQuery({
    queryKey: ['activity-log', source, severity],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (source) params.set('source', source);
      if (severity) params.set('severity', severity);
      const r = await fetch(`/api/activity-log?${params.toString()}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      return r.json();
    },
  });

  const filtered = (data?.rows || []).filter((r: any) =>
    !search || (r.message || '').toLowerCase().includes(search.toLowerCase()) ||
                (r.event_type || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Activity Log</h1>
      <p className="text-sm text-textSecondary">System events distinct from the audit log — service starts, license refreshes, partner links, integration events.</p>
      <div className="flex gap-3 items-end flex-wrap">
        <div className="flex-1 min-w-48">
          <label className="block text-sm text-textSecondary mb-1">Search</label>
          <input className="input" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="event_type or message" />
        </div>
        <div>
          <label className="block text-sm text-textSecondary mb-1">Source</label>
          <select className="input" value={source} onChange={(e) => setSource(e.target.value)}>
            <option value="">All</option>
            {['service', 'partner', 'license', 'system', 'integration'].map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm text-textSecondary mb-1">Severity</label>
          <select className="input" value={severity} onChange={(e) => setSeverity(e.target.value)}>
            <option value="">All</option>
            {['info', 'warn', 'error'].map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
      </div>
      <div className="card p-0 overflow-hidden">
        <table className="table">
          <thead><tr><th>Time</th><th>Source</th><th>Event</th><th>Severity</th><th>Message</th></tr></thead>
          <tbody>
            {filtered.map((r: any) => (
              <tr key={r.activity_id} className="hover:bg-elevated">
                <td className="text-xs">{new Date(r.occurred_at).toLocaleString()}</td>
                <td>{r.source}</td>
                <td className="font-mono text-xs">{r.event_type}</td>
                <td><span className={SEVERITY_COLORS[r.severity] || 'badge'}>{r.severity}</span></td>
                <td>{r.message || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!filtered.length && <div className="p-6 text-center text-textSecondary">No activity.</div>}
      </div>
      {data?.total !== undefined && <div className="text-sm text-textSecondary">{data.total} total events.</div>}
    </div>
  );
}
